import { render, staticRenderFns } from "./labelsKnowledge.vue?vue&type=template&id=823da7f4&"
import script from "./labelsKnowledge.vue?vue&type=script&lang=js&"
export * from "./labelsKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports